import { DatePipe, formatDate } from '@angular/common';
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { FieldTypeCode, TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';
import { FormsService } from '../../../../services/forms.service';
import { TableComplexModalComponent } from '../modals/table-complex-modal/table-complex-modal.component';

@Component({
    selector: 'app-component-table-complex',
    templateUrl: './table-complex.component.html',
    styleUrls: ['./table-complex.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComplexComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup = this.formBuilder.group({});
    @Output() tableEmit = new EventEmitter();

    formFieldConfig: any;
    gridTable = "";
    dataTableComplexField = [];
    IdUpdate = -1;
    IdMapping = "";
    groupTableComplex = [];
    result: any;
    tableoption: any;
    tableName: string;
    isVisible = false;
    template: '';
    tooltip: string;
    fieldDataInfo: any;
    headers: any[] = [];
    values: any[] = [];
    tableShowValues: any[] = [];
    cols: string[] = [];
    tableContent: [];
    taxCode="";
    formCode="";

    constructor(
        private formsService: FormsService,
        private modal: NzModalService,
        private cdref: ChangeDetectorRef,
        private datePipe: DatePipe,
        private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.fieldDataInfo = this.formFieldInfo;
        this.template = this.fieldDataInfo && this.fieldDataInfo.formFieldConfig ? JSON.parse(this.fieldDataInfo.formFieldConfig).template : null;
        this.formCode=localStorage.getItem('FORM_CODE');
        this.taxCode=localStorage.getItem('TAXCODE');
        
        let tableData = JSON.parse(localStorage.getItem('VALUE_' + this.formFieldInfo.formCode +'_'+  this.taxCode + '_'+ this.fieldDataInfo.fieldCode));
        if (tableData) {
            this.tableShowValues = tableData;
        }
        this.generateTableComplexField();
    }


    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    displayName(item: any) {
        var displayName = item.name;
        if (item.formFieldConfig) {
            var formFieldConfig = JSON.parse(item.formFieldConfig);
            if (formFieldConfig && formFieldConfig.displayText)
                displayName = formFieldConfig.displayText;
        }

        return displayName;
    }

    generateTableComplexField() {
        this.formFieldConfig = JSON.parse('{ "pattern": "" }'); //default
        var fieldConfig = JSON.parse('{ "propdownPattern": "" }'); //default
        var itemSubSection = "", condition = "", conditionExtend = "";

        try {
            if (this.formFieldInfo.formFieldConfig) {
                this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
                itemSubSection = this.formFieldConfig.itemSubSection ? this.formFieldConfig.itemSubSection : "";
                condition = this.formFieldConfig.condition ? this.formFieldConfig.condition : "";
                conditionExtend = this.formFieldConfig.conditionExtend ? this.formFieldConfig.conditionExtend : "";
                this.tableoption = this.formFieldConfig.tableconfig ? this.formFieldConfig.tableconfig : "";
                this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
                this.tableName = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            }

            if (this.formFieldInfo.fieldConfig) {
                fieldConfig = JSON.parse(this.formFieldInfo.fieldConfig);
                if (fieldConfig.tableconfig && this.tableoption == "")
                    this.tableoption = fieldConfig.tableconfig;
            }
        }
        catch (err) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }'); //default
            fieldConfig = JSON.parse('{ "propdownPattern": "" }'); //default
        }

        if (this.formFieldConfig && this.formFieldConfig.template) {
            var dataTemplate = this.formFieldConfig.template.split('#');
            var formCode = dataTemplate[0];
            var formVersion = dataTemplate.length > 1 ? dataTemplate[1] : 1;
            return this.formsService.getFieldCreateForm({ FormCode: formCode,  Enviroment: 2,  Version: formVersion}).subscribe(
                res => {
                    if (res) {
                        localStorage.setItem(this.formFieldInfo.formCode + 1 + formVersion, JSON.stringify(res));
                        let result=res.result.value.result;
                        this.headers = result;
                    }
                },
                error => {
                    console.log("HTTP error: " + error);
                }
            )   
        }
    }

    ValidatorOSBFieldObject(): boolean {
        if (this.formFieldInfo && this.formFieldInfo.formFieldConfig) {
            this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
            return (this.formFieldConfig.osbconfig) ? true : false;
        }

        return false;
    }

    editData(event:any,i: number) {
        let obj = this.tableShowValues[i];
        this.openModal(event,obj, i);
    }

    openModal(event:any,data, idx) {
        if(event!=null && event.pointerType===''){// prevent press enter to open modal
            return;
        }

        const modal: NzModalRef = this.modal.create({
            nzTitle: data ? TITLE.UPDATE_DATA : TITLE.ADD_DATA,
            nzContent: TableComplexModalComponent,
            nzComponentParams: {
                template: this.template,
                data: data ? data : null,
                title: data ? TITLE.UPDATE_DATA : TITLE.ADD_DATA,
                formFieldCode: this.formFieldInfo.fieldCode ? this.formFieldInfo.fieldCode : null,
            },
            nzWidth: 980,
            nzMaskClosable: false,
            nzAutofocus:null,
        })
        
        modal.afterClose.subscribe(res => this.afterCloseModal(res, data ? idx : -1));
    }

    displayDataAfterCloseModal(res, index) {
        if (res) {
            if (index == -1) {
                this.values.push(res);
                var showValue = structuredClone(res);
                let prop: keyof typeof res;
                for (prop in res) {
                    if (prop.indexOf(FieldTypeCode.DATE) > -1 && res[prop]) {
                        showValue[prop] = formatDate(new Date(res[prop]), "dd/MM/yyyy", "en-US")
                    }
                    else if (prop.indexOf(FieldTypeCode.DATETIME) > -1 && res[prop]) {
                        showValue[prop] = formatDate(new Date(res[prop]), "dd/MM/yyyy HH:mm", "en-US")
                    }
                    else {
                        showValue[prop] = res[prop];
                    }
                }
                this.tableShowValues.push(showValue);
            }
            else {
                this.values[index] = res;
                var showValue = structuredClone(res);
                let prop: keyof typeof res;
                for (prop in res) {
                    if (prop.indexOf(FieldTypeCode.DATE) > -1 && res[prop]) {
                        showValue[prop] = formatDate(new Date(res[prop]), "dd/MM/yyyy", "en-US")
                    }
                    else if (prop.indexOf(FieldTypeCode.DATETIME) > -1 && res[prop]) {
                        showValue[prop] = formatDate(new Date(res[prop]), "dd/MM/yyyy HH:mm", "en-US")
                    }
                    else {
                        showValue[prop] = res[prop];
                    }
                }
                this.tableShowValues[index] = showValue;
            }
            localStorage.setItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_'+ this.formFieldInfo.fieldCode, JSON.stringify(this.tableShowValues));
        }
    }

    afterCloseModal(data, index) {
        this.tableEmit.emit({ value: this.values, fieldCode: this.formFieldInfo.fieldCode });
        if(data){
            this.values[index] = this.tableShowValues[index] = data;
            this.displayDataAfterCloseModal(data, index);   
        }
        else if(this.values[index]){
            this.tableShowValues[index] = this.values[index];
            this.displayDataAfterCloseModal(this.values[index], index);
        }
        else{
            let jsonParse = localStorage.getItem('VALUE_' + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.formFieldInfo.fieldCode);
            let temp = JSON.parse(jsonParse);
            data = temp[index];
            this.displayDataAfterCloseModal(data, index);
        }
    }

    deleteData(i: number) {
        if (i > -1) {
            this.values.splice(i, 1);
            this.tableShowValues.splice(i, 1);
            localStorage.setItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_'+ this.formFieldInfo.fieldCode, JSON.stringify(this.tableShowValues));
        }
    }

    toPropertyArray(cell: object) {
        return Object.keys(cell);
    }

    cellValue(row, cell) {
        let data = {
            cellValue: '',
            saveData: ''
        }

        let temp = '';
        if (cell.fieldTypeCode == FieldTypeCode.RADIO_BUTTON) {
            if (row[cell.fieldCode]) {
                let splittedValue = row[cell.fieldCode].split('|')
                if (splittedValue.length > 0) {
                    if (splittedValue.length == 3) {
                        temp = splittedValue[1] + ':' + splittedValue[2];
                    }
                    else {
                        temp = splittedValue[1];
                        if(!temp)
                        temp = splittedValue[0];
                    }
                }
            }
            data.saveData = row[cell.fieldCode];
            data.cellValue = temp;
            return data;
        } 
        if (cell.fieldTypeCode == FieldTypeCode.SELECTLIST_SINGLE) {
            if(row[cell.fieldCode]){
                let splittedValue=row[cell.fieldCode].split('|')
                if(splittedValue.length>0){
                    temp=splittedValue[1];
                    if(!temp)
                    temp = splittedValue[0];
                }
            }

            data.saveData = row[cell.fieldCode];
            data.cellValue = temp;
            return data;
        } 
        else if (cell.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
            if(row[cell.fieldCode]){
                let splittedValue : Array<string> = row[cell.fieldCode].split('#');
                splittedValue.forEach(element => {
                    let data = element.includes('|') ? element.split('|') : (element.includes(',') ? element.split(',') : null);
                    
                    if (data) {
                        if (data.length === 3) {
                            temp += data[1] + ':' + data[2];
                        }
                        else {
                            temp += data[1];
                        }
                    }
                });
            }

            if(temp == 'undefined' || temp == null)
                temp = '';

            temp = temp.trim();
        
            if(temp.lastIndexOf(',')>-1){
                temp = temp.slice(0,-1);
            }

            if(temp.toUpperCase().includes('EMAIL') && temp[temp.length-1] != ';'){
                temp = temp.trim().concat(';');
            }

            data.saveData = row[cell.fieldCode];
            data.cellValue = temp;
            return data;
        }
        else if (cell.fieldTypeCode == FieldTypeCode.DATE) {
            let value = row[cell.fieldCode];
            try{
                temp= (value != null || value != '') ? this.datePipe.transform(value, 'dd/MM/yyyy') : null;
                row[cell.fieldCode]=value;
            }
            catch(except){
                temp= (value != null || value != '') ? value : null;
                row[cell.fieldCode]=value;
            }
            
            data.saveData = row[cell.fieldCode];
            data.cellValue = temp;
            return data;
        }
        else if (cell.fieldTypeCode == FieldTypeCode.DATETIME) {
            let value = row[cell.fieldCode];
            try{
                temp= (value != null || value != '') ? this.datePipe.transform(value, 'dd/MM/yyyy HH:mm') : null;
                row[cell.fieldCode]=value;
            }
            catch(except){
                temp= (value != null || value != '') ? value : null;
                row[cell.fieldCode]=value;
            }

            data.saveData = row[cell.fieldCode];
            data.cellValue = temp;
            return data;
        }
        else {
            data.saveData = row[cell.fieldCode];
            data.cellValue = row[cell.fieldCode];
            return data;
        }
    }	
}